;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'clsx';
import NextImage from 'next/image';
import PropTypes from 'prop-types';

import { BLOCKS } from '@contentful/rich-text-types';

import EntryLink from 'components/ui/Link/EntryLink';
import RichText from 'components/ui/RichText';
import Text from 'components/ui/Text';

import { addProtocol } from 'utils/url';

import styles from './CardDualAspectNews.module.scss';

const copyOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => (
            <Text
                className={styles.copyText}
                baseTheme="bodySmall"
                themes={{ large: 'bodyMedium' }}
            >
                {children}
            </Text>
        ),
    },
};

const CardDualAspectNews = ({ headline, copy, image, link, index }) => {
    const Wrapper = link ? EntryLink : 'div';

    const className = cx(styles.root, {
        [styles.isEven]: index % 2 === 0,
        [styles.isLink]: !!link,
    });

    const wrapperProps = {
        className,
        ...(link && { entry: link }),
    };

    return (
        <Wrapper {...wrapperProps}>
            <article className={styles.inner}>
                {image?.url && (
                    <div className={styles.imageContainer}>
                        <NextImage
                            className={styles.image}
                            src={addProtocol(image.url)}
                            width={image.width}
                            height={image.height}
                            sizes="(max-width: 768px) 90vw, (max-width: 768px) 50vw, 33vw"
                            alt={image.description || ''}
                        />
                    </div>
                )}
                {headline && (
                    <Text
                        className={styles.headline}
                        baseTheme="displayXXSmall"
                        themes={{
                            large: 'displayXSmall',
                        }}
                    >
                        {headline}
                    </Text>
                )}
                {copy && (
                    <div className={styles.copy}>
                        <RichText richText={copy} overrides={copyOverrides} />
                    </div>
                )}
            </article>
        </Wrapper>
    );
};

CardDualAspectNews.propTypes = {
    headline: PropTypes.string,
    copy: PropTypes.object,
    image: PropTypes.object,
    link: PropTypes.object,
    index: PropTypes.number,
};

export default CardDualAspectNews;
